const nameCharacters = [
  {
    '_id': '5da237699734fdcb7bef8f63',
    'name': 'Helga G. Pataki',
    'image': 'https://vignette.wikia.nocookie.net/heyarnold/images/e/e5/Helga_Pataki.png/revision/latest/scale-to-width-down/266?cb=20190816021807'
  },
  {
    '_id': '5da237699734fdcb7bef8f8b',
    'name': 'Shelley',
    'image': 'https://vignette.wikia.nocookie.net/heyarnold/images/c/cb/Shelley.jpg/revision/latest/scale-to-width-down/310?cb=20120527025256'
  },
  {
    '_id': '5da237699734fdcb7bef902e',
    'name': 'Helga\'s Parrot (bird)',
    'image': 'https://vignette.wikia.nocookie.net/heyarnold/images/f/f1/Helga%27s_parrot%2C_bird.jpg/revision/latest/scale-to-width-down/310?cb=20100307071524'
  },
  {
    '_id': '5da237699734fdcb7bef8fb8',
    'name': 'Shelley',
    'image': 'https://vignette.wikia.nocookie.net/heyarnold/images/c/cb/Shelley.jpg/revision/latest/scale-to-width-down/310?cb=20120527025256'
  }
];

export default nameCharacters;
